import styles from './Lightbox.module.scss';
import React from 'react';
import { Backdrop, Image } from '@wienenergiegithub/ui-next';
import { Dialog } from '@ariakit/react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// TODO: Bring together regular Lightbox component and this one.
const Lightbox = ({ className, imageStyles, open, store, ...props }) => {
  return (
    <Dialog
      backdrop={
        <Backdrop
          animated
          className={classNames(styles.backdrop, { [styles.open]: open })}
          dismissAriaLabel="Vergrößerte Ansicht beenden"
          hasCloseButton
          isTransparent={false}
          store={store}
        />
      }
      className={classNames(
        styles.container,
        { [styles.open]: open },
        className,
      )}
      render={<Image className={styles.image} style={imageStyles} {...props} />}
      store={store}
    />
  );
};

Lightbox.propTypes = {
  imageStyles: PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    transition: PropTypes.string,
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  /** `useDialogStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
};

export default Lightbox;
